'use strict';

module.exports = {
  template: require('./create.html'),
  controller: require('./create.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/create/index.js
 ** module id = 151
 ** module chunks = 0
 **/